export const isObject = (prop: any) => {
  return typeof prop === 'object' && prop !== null;
};
